import { Navigate } from "react-router-dom";

import { useAuth } from "@/modules/auth";

export const LoginPage = () => {
  const { operator, loading, login } = useAuth();
  if (loading) {
    return <div>Loading...</div>;
  }

  if (operator) {
    // Check if there's a saved redirect path from a deep link
    const redirectPath = localStorage.getItem("auth:redirectPath");

    // If we have a saved path, redirect there and clean up
    if (redirectPath) {
      localStorage.removeItem("auth:redirectPath");
      return <Navigate to={redirectPath} />;
    }

    // Default redirect to home
    return <Navigate to="/" />;
  }

  return (
    <div>
      <button onClick={login}>Login</button>
    </div>
  );
};
